<template>
  <div class="page-modal">
    <widgetModal :title="'Switch to Normal Account'"
      :subtitle="verificationStep ? 'Please enter verification code' : 'Please enter your account details'"
      :btnlefttext="verificationStep ? 'Verify' : 'Switch Account'" btncentertext="Cancel" :leftloading="loading"
      :rightloading="false" :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="450px" :hiderightbtn="true"
      @onLeftClick="onConfirm()" @onCenterClick="onCancel">
      <div class="widget-modal-body-noscoll">
        <template v-if="!verificationStep">
          <widgetInputWrapper v-if="false" title="Email">
            <widgetInput type="email" v-model="form.email" placeholder="Enter your email"></widgetInput>
          </widgetInputWrapper>
          <widgetInputWrapper title="Password">
            <widgetInput type="password" v-model="form.password" placeholder="Enter your password"></widgetInput>
          </widgetInputWrapper>

          <widgetInputWrapper title="Confirm Password">
            <widgetInput type="password" v-model="form.confirmPassword" placeholder="Confirm your password">
            </widgetInput>
          </widgetInputWrapper>
        </template>

        <template v-else>
          <widgetInputWrapper title="Verification Code">
            <widgetInput type="text" v-model="form.verificationCode" placeholder="Enter verification code">
            </widgetInput>
          </widgetInputWrapper>
          <div class="resend-code">
            <span @click="resendCode" :class="{ disabled: resendCountdown > 0 }">
              {{ resendCountdown > 0 ? `Resend code in ${resendCountdown}s` : 'Resend code' }}
            </span>
          </div>
        </template>
      </div>
    </widgetModal>
  </div>
</template>

<script>
import { eventBus } from "@/main";

export default {
  name: "switch-normal-account-modal",
  data() {
    return {
      form: {
        email: "",
        password: "",
        confirmPassword: "",
        verificationCode: ""
      },
      loading: false,
      verificationStep: false,
      resendCountdown: 0
    };
  },
  methods: {
    async onConfirm() {
      let vm = this;

      if (!vm.verificationStep) {
        if (vm.$isFieldsValidated(vm.form, vm.getValidationRules())) {
          vm.loading = true;
          try {
            await vm.$store.dispatch("INITIATE_SWITCH_TO_NORMAL_ACCOUNT", {
              email: vm.form.email,
              password: vm.form.password
            });
            // vm.verificationStep = true;
            // vm.startResendCountdown();
            // vm.$notify({
            //   group: "status",
            //   title: "Success",
            //   text: "Verification code sent to your email",
            //   type: "success",
            //   duration: 3000
            // });
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Account switched successfully",
              type: "success",
              duration: 3000
            });
            vm.$emit("success");
          } catch (error) {
            vm.$notify({
              group: "status",
              title: "Error",
              text: error.response?.data?.error || "Something went wrong",
              type: "error",
              duration: 3000
            });
          }
          vm.loading = false;
        }
      } else {
        if (vm.form.verificationCode) {
          vm.loading = true;
          try {
            await vm.$store.dispatch("COMPLETE_SWITCH_TO_NORMAL_ACCOUNT", {
              email: vm.form.email,
              password: vm.form.password,
              verificationCode: vm.form.verificationCode
            });
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Account switched successfully",
              type: "success",
              duration: 3000
            });
            vm.$emit("success");
          } catch (error) {
            vm.$notify({
              group: "status",
              title: "Error",
              text: error.response?.data?.error || "Invalid verification code",
              type: "error",
              duration: 3000
            });
          }
          vm.loading = false;
        }
      }
    },

    getValidationRules() {
      let vm = this;
      return {
        // email: {
        //   run: (value) => {
        //     if (!value) return "Email is required";
        //     if (!vm.$isValidEmail(value)) return "Please enter a valid email";
        //     return false;
        //   }
        // },
        password: {
          run: (value) => {
            if (!value) return "Password is required";
            if (value.length < 6) return "Password must be at least 6 characters";
            return false;
          }
        },
        confirmPassword: {
          run: (value) => {
            if (!value) return "Please confirm your password";
            if (value !== vm.form.password) return "Passwords do not match";
            return false;
          }
        }
      };
    },

    startResendCountdown() {
      this.resendCountdown = 60;
      const timer = setInterval(() => {
        this.resendCountdown--;
        if (this.resendCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    async resendCode() {
      if (this.resendCountdown > 0) return;

      try {
        await this.$store.dispatch("RESEND_VERIFICATION_CODE", {
          email: this.form.email
        });
        this.startResendCountdown();
        this.$notify({
          group: "status",
          title: "Success",
          text: "Verification code resent",
          type: "success",
          duration: 3000
        });
      } catch (error) {
        this.$notify({
          group: "status",
          title: "Error",
          text: error.response?.data?.error || "Failed to resend code",
          type: "error",
          duration: 3000
        });
      }
    },

    onCancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {
  .widget-modal-body-noscoll {
    padding: 20px 0;
  }
}

.resend-code {
  text-align: right;
  margin-top: 8px;

  span {
    color: var(--primary-color);
    cursor: pointer;
    font-size: 14px;

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>